import React, { useEffect, useState, useMemo } from "react";
import "../../StyleSheet/MainComponent/Role/Role.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RetrieveInvoiceActions } from "../../Redux/Slice";
import ReactTable from "../../Component/AppComponent/Table";
import home from "../../Assets/AppComponent/Logo/Home.svg";
import Header from "../../Component/AppComponent/Header/Header";


const Sent = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const navigate = useNavigate();
  const RetrieveInvoiceRes = useSelector((state) => state.RetrieveInvoiceData)
  const dispatch = useDispatch()
  const [tabledata, settabledata] = useState([])
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [datacount, setdatacount] = useState();
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    dispatch(RetrieveInvoiceActions())
  }, [])

  useEffect(() => {
    //console.log(RetrieveInvoiceRes)
    if (RetrieveInvoiceRes.RetrieveInvoiceData) {
      settabledata(RetrieveInvoiceRes.RetrieveInvoiceData)
      setdatacount(RetrieveInvoiceRes?.values)
    } else {
      settabledata([])

    }
  }, [RetrieveInvoiceRes])
  const breadcrumbsData = [
    {
      id: "1",
      href: "/",
      source: home,
      title: "DASHBOARD",
    },
  ];
  const InvoiceColumn = useMemo(
    () => [
      {
        Header: "Plant",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original.plant != null ? row.row.original.plant.plant : "--"}</span>

            </>
          );
        },
      },
      {
        Header: "Project",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original.project != null ? row.row.original.project.project : "--"}</span>

            </>
          );
        },
      },
      {
        Header: "Project Wbs",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {/* <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              > */}
              <span>{row.row.original.project_wbs != null ? row.row.original.project_wbs.project_wbs : "--"}</span>
              {/* </div> */}
            </>
          );
        },
      },
      {
        Header: "Documents",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {/* <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              > */}
              {row.row.original.invoice_zip != null ?
                (<a href={row.row.original.invoice_zip} onClick={(e) => {
                  const parts = row.row.original.invoice_zip.split('/media');
                  const urlAfterMedia = parts.length > 1 ? '/media' + parts[1] : '';
                  //console.log(urlAfterMedia);
                  window.open(String("http://localhost:8000/" + urlAfterMedia), "_blank")
                }} >
                  Download Invoice
                </a>) : "--"}
              {/* </div> */}
            </>
          );
        },
      },


    ],
    []
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>

        <Header breadCrumbsData={breadcrumbsData} heading="Mail History" />

        {/* <PageTemplate data={tabledata} tableType="invoicedata"></PageTemplate> */}
        <ReactTable
          columns={InvoiceColumn}
          data={tabledata}
          pagesize={pagesize}
          pageindex={pageindex}
          dtpagesize={dtpagesize}
          dtpageindex={dtpageindex}
          datacount={datacount}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          search={true}

        />

      </div>
    </>
  );
};

export default Sent;

